export const payMiseFeeReducer = (state = [], action) => {
  switch (action.type) {
    case "GET_MISC_FEE_DATA":
      return action.payload;
    default:
      return state;
  }
};
